import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@bapecom/auth';
import App from './App';
import './index.css';

// Use env variable for API URL (only accept absolute http(s) URLs in production)
const DEFAULT_PROD_API_BASE = 'https://api.bapecom.com';
const API_BASE = (() => {
  const raw = import.meta.env.VITE_API_URL;
  if (raw && /^https?:\/\//.test(raw)) {
    try {
      const u = new URL(raw);
      const isSameHost = typeof window !== 'undefined' && u.hostname === window.location.hostname;
      const isBapecomHost = u.hostname === 'bapecom.com' || u.hostname.endsWith('.bapecom.com');
      // In production we don't currently have a working same-origin /api proxy.
      // If someone configured VITE_API_URL to point at the portal domain, use the Worker API instead.
      if (!import.meta.env.DEV && (isSameHost || isBapecomHost)) return DEFAULT_PROD_API_BASE;
      return raw;
    } catch {
      // ignore parse errors
    }
  }
  return import.meta.env.DEV ? 'http://127.0.0.1:8787' : DEFAULT_PROD_API_BASE;
})();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider apiBaseUrl={API_BASE}>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
